import { BaseModal } from './baseModal'
import { createSelectors } from '../utils/selectorUtils';
import { createLogger } from '../utils/debugLogger';
const l = createLogger('ModalDepartureDate.js');

export class ModalDepartureDate extends BaseModal {
    static Selectors = createSelectors({
        INPUT: {
            DEPARTURE_MONTH: `data-ts-departure-month`
        }
    });

    static Config = {
        QUERY_STRING_KEY: 'filterdeparturestartdate'
    }

    static createModal(queryStringManager) {
        return BaseModal.create.call(this, 'ModalDepartureDate', queryStringManager);
    }

    getSelectedValues() {
        const val = document.querySelector(this.constructor.Selectors.INPUT.DEPARTURE_MONTH).value;
        return [[this.constructor.Config.QUERY_STRING_KEY, val]];
    }

    clearSelected = () => {
        l.log(`${this.modalName}: custom clear`);
        document.querySelector(this.constructor.Selectors.INPUT.DEPARTURE_MONTH).value = '';
    }
}
